export default __webpack_public_path__ + "static/media/camera_dark.a7424079.png";